import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { IScriptRedirect } from '@agent/core/phone/script-redirection/models/script-redirection';
import { IScriptRedirectionService } from '@agent/core/phone/script-redirection/script-redirection.service';
import { Component, Inject, Input } from '@angular/core';
import { NG1_SCRIPT_REDIRECTION } from '@commons/core/core.provider.ajs';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

@Component({
  selector: 'chat-script-redirection-actions',
  templateUrl: 'chat-script-redirection-actions.component.html',
  styleUrls: ['./chat-script-redirection-actions.component.scss'],
})
export class ChatScriptRedirectionActionsComponent extends DisplayDeprecatedComponent {
  @Input()
  responseId: string;

  public toggleMoreMenu: boolean = false;

  constructor(
    @Inject(NG1_SCRIPT_REDIRECTION) private readonly scriptRedirectionService: IScriptRedirectionService,
    private readonly chatSocketService: ChatSocketService,
    private readonly router: AgentDesktopRouter
  ) {
    super();
  }

  get scriptRedirect(): IScriptRedirect {
    return this.scriptRedirectionService
      .getScriptRedirect(this.responseId)
      .getOrElseFunc(() => this.scriptRedirectionService.createScriptRedirect(this.responseId));
  }

  get canValidateScriptRedirect(): boolean {
    return (
      this.scriptRedirectionService.canValidateScriptRedirect(this.responseId) &&
      !!this.scriptRedirect.target &&
      this.scriptRedirect.target.type === this.scriptRedirect.type
    );
  }

  validateScriptRedirection(): void {
    if (this.canValidateScriptRedirect) {
      this.scriptRedirectionService.executeScriptRedirection(this.responseId).then(() => {
        this.chatSocketService.sendScriptRedirectionMessage();
      });
    }
  }

  cancelScriptRedirection(): void {
    this.router.navigateFromLastChild(['..']);
  }

  unparkContactAndAgent(): void {
    this.scriptRedirectionService.unparkContactAndAgent(this.responseId).then(() => {
      this.router.navigateFromLastChild(['..']);
    });
  }
}
